// Number-font (dashboard tabular numerals) preference — applied globally via CSS variables.

export const NUM_FONTS = [
  { id: "space", label: "Space Grotesk", family: "'Space Grotesk', 'Inter', sans-serif", weight: 600, letter: "-0.015em",
    tagline: "Modern geometrik · Şu anki varsayılan" },
  { id: "manrope", label: "Manrope", family: "'Manrope', 'DM Sans', sans-serif", weight: 700, letter: "-0.02em",
    tagline: "Zarif · Yüksek okunabilirlik" },
  { id: "geist", label: "Geist Mono", family: "'Geist Mono', 'JetBrains Mono', monospace", weight: 600, letter: "-0.02em",
    tagline: "Temiz monospace · Vercel tarzı" },
  { id: "ibm", label: "IBM Plex Sans", family: "'IBM Plex Sans', 'Inter', sans-serif", weight: 600, letter: "-0.01em",
    tagline: "Kurumsal · Klasik" },
  { id: "onest", label: "Onest", family: "'Onest', 'Space Grotesk', sans-serif", weight: 700, letter: "-0.015em",
    tagline: "Sıcak · Yuvarlak hatlı" },
  { id: "jetbrains", label: "JetBrains Mono", family: "'JetBrains Mono', monospace", weight: 500, letter: "-0.02em",
    tagline: "Klasik monospace · Kodcu" },
];

const KEY = "madymark_num_font";

export function getNumFont() {
  return localStorage.getItem(KEY) || "space";
}

export function applyNumFont(id) {
  const f = NUM_FONTS.find(x => x.id === id) || NUM_FONTS[0];
  const root = document.documentElement.style;
  root.setProperty("--font-mono-num", f.family);
  root.setProperty("--font-weight-num", String(f.weight));
  root.setProperty("--letter-num", f.letter);
  localStorage.setItem(KEY, f.id);
  return f;
}

export function bootNumFont() {
  applyNumFont(getNumFont());
}
